import './NotReadyPage.css'

function NotReadyPage() {
    return(
        <div className="notReadyPage__section">
            <p>Страница находится в разработке</p>
        </div>
    )
}

export default NotReadyPage